import posthogService from './lib/services/posthogService'
import sentryService from './lib/services/sentryService'

posthogService.init()
sentryService.init()
